import React, { ReactNode, useId } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import styled from "styled-components";

export type TooltipPosition = "top" | "bottom" | "left" | "right";

interface TooltipProps {
  content?: ReactNode;
  children: ReactNode;
  position?: TooltipPosition;
  tooltipId?: string;
  /** Milliseconds to wait before showing. Defaults to 200. */
  delayShow?: number;
  /** Keep the tooltip open while hovered so its content can be interacted with. */
  clickable?: boolean;
  /** Follow the cursor. Defaults to true; set false for anchored, clickable tooltips. */
  float?: boolean;
  /** Called once the tooltip becomes visible (after delayShow). */
  afterShow?: () => void;

  style?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
}

const TooltipContainer = styled.span``;

const Tooltip: React.FC<TooltipProps> = ({
  tooltipId,
  content,
  children,
  delayShow = 200,
  clickable = false,
  float = true,
  afterShow,
  style,
  contentStyle,
}) => {
  const id = tooltipId || useId();
  if (!content) return <>{children}</>;

  return (
    <>
      <TooltipContainer
        style={style}
        data-tooltip-id={id}
        data-tooltip-content={typeof content === "string" ? content : undefined}
      >
        {children}
      </TooltipContainer>
      <ReactTooltip
        style={{
          userSelect: clickable ? "auto" : "none",
          zIndex: 9999,
          ...contentStyle,
        }}
        float={float}
        clickable={clickable}
        delayShow={delayShow}
        afterShow={afterShow}
        id={id}
      >
        {typeof content !== "string" ? content : null}
      </ReactTooltip>
    </>
  );
};

export default Tooltip;
